<body>
    <div class="container">
        <table class="table-selects">
            <thead>
                <tr>
                    <th class="flex">
                        <div class="divHeader">
                            <input class="largo" type="date" name="dataExibirPre" [(ngModel)]="dataExibirPre">
                            <button class="atualizar" (click)="atualizaData()">Atualizar</button>
                        </div>
                        <div class="divHeader central">
                            <h1>TIME TABLE LCB</h1>
                        </div>
                        <div class="divHeader">
                            <button class="btn-frete icone-setting" mat-button
                                (click)="exportToExcel(timeTableGeral,'RECCONT')"><i-feather
                                    name="printer"></i-feather>REC Container</button>
                            <button class="btn-frete icone-setting" mat-button
                                (click)="exportToExcel(timeTableGeral,'EXP')"><i-feather
                                    name="printer"></i-feather>EXP</button>
                            <button class="btn-frete icone-setting" mat-button
                                (click)="exportToExcel(timeTableGeral,'INT')"><i-feather
                                    name="printer"></i-feather>INT</button>
                            <button class="btn-frete icone-setting" mat-button
                                (click)="exportToExcel(timeTableGeral,'EMB')"><i-feather
                                    name="printer"></i-feather>EMB</button>
                            <button class="btn-frete icone-setting" mat-button
                                (click)="exportToExcel(timeTableGeral,'RECSIDER')"><i-feather
                                    name="printer"></i-feather>REC SIDER</button>
                        </div>
                    </th>
                </tr>
            </thead>
        </table>
        <table>
            <thead>
                <tr>
                    <th class="flexEdit">
                        <div class="data">
                            <span>{{ dataExibir | date : 'dd/MM/yyyy' }}</span>
                        </div>
                        <div class="flex1">
                            Selecione as áreas que deseja visualizar
                            <!-- <input type="checkbox" [(ngModel)]="RECCONT"> REC CONTAINER
                            <input type="checkbox" [(ngModel)]="EXP"> EXP
                            <input type="checkbox" [(ngModel)]="INT"> INT
                            <input type="checkbox" [(ngModel)]="EMB"> EMB
                            <input type="checkbox" [(ngModel)]="RECSIDER"> REC SIDER -->

                            <input type="checkbox" [(ngModel)]="RECCONT" (change)="filtrarItensExcesso()"> REC CONTAINER
                            <input type="checkbox" [(ngModel)]="EXP" (change)="filtrarItensExcesso()"> EXP
                            <input type="checkbox" [(ngModel)]="INT" (change)="filtrarItensExcesso()"> INT
                            <input type="checkbox" [(ngModel)]="EMB" (change)="filtrarItensExcesso()"> EMB
                            <input type="checkbox" [(ngModel)]="RECSIDER" (change)="filtrarItensExcesso()"> REC SIDER
                        </div>
                    </th>
                </tr>
            </thead>
        </table>

        <div class="table-container scrollable-container">
            <table class="geralTable">
                <thead class="sticky-header">
                    <tr>
                        <th class="titulo-coluna" colspan="1">
                            <span class="semFundo">HORÁRIO</span>
                        </th>
                        <th *ngIf="RECCONT" class="titulo-coluna" colspan="4">
                            <span class="semFundo">REC CONTAINER</span>
                        </th>
                        <th *ngIf="RECSIDER" class="titulo-coluna" colspan="3">
                            <span class="semFundo">REC SIDER</span>
                        </th>
                        <th *ngIf="EXP" class="titulo-coluna" colspan="3">
                            <span class="semFundo">EXP</span>
                        </th>
                        <th *ngIf="INT" class="titulo-coluna" colspan="4">
                            <span class="semFundo">INT</span>
                        </th>
                        <th *ngIf="EMB" class="titulo-coluna" colspan="2">
                            <span class="semFundo">EMB</span>
                        </th>

                    </tr>
                </thead>
                <tbody *ngFor="let _ of [].constructor(24); let i = index">
                    <tr class="corpoTimeTable">
                        <td class="centralizado" [ngClass]="classHora ? classHora[i] : ''"><br>
                            <!-- <abbr style="color: #cccbc9; font-size: 4.5vh; font-weight: bold;">{{ dataExibir | date :
                                'dd/MM' }}</abbr><br> -->
                            <div>
                                <abbr style="color: #cccbc9; font-size: 4.5vh; font-weight: bold;">{{i}}:00 </abbr>
                            </div><br>
                            <div> <span *ngIf="RECCONT"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">REC CONTAINER:
                                    </abbr> {{ valorItemVolume[i][0].toFixed(2) }}</span></div>
                            <div><span *ngIf="RECSIDER"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">REC SIDER: </abbr>
                                    {{
                                    valorItemVolume[i][1].toFixed(2) }}</span></div>
                            <div><span *ngIf="EXP"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">EXP:
                                    </abbr> {{ valorItemVolume[i][2].toFixed(2) }} </span></div>
                            <div><span *ngIf="INT"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">INT:
                                    </abbr> {{ valorItemVolume[i][3].toFixed(2) }} </span></div>
                            <div><span *ngIf="EMB"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">EMB:
                                    </abbr> {{ valorItemVolume[i][4].toFixed(2) }} </span></div>
                        </td>
                        <!-- <td class="volumes">Volumes: </td> -->
                        <td [ngClass]="timeTableGeral[i]['RECCONT'][0]?.statusEntrega"
                            (click)="timeTableGeral[i]['RECCONT'][0] ? editDialog(timeTableGeral[i]['RECCONT'][0]) : editDialog2('RECCONT')"
                            *ngIf="RECCONT">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][0]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][0]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][0]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][0]?.lastUpdate"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][0]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['RECCONT'][0]?.UpdateByUser }}
                                </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['RECCONT'][0]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][0]?.ID }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['RECCONT'][0]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][0]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][0]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][0]?.Transportadora"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][0]?.Transportadora }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][0]?.Plate "><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Placa: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][0]?.Plate }}</span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['RECCONT'][0]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][0]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][0]?.Volumes"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][0]?.Volumes }}</span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][0]?.SequenciaLCB"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Registro: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][0]?.SequenciaLCB }}</span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['RECCONT'][0] && (timeTableGeral[i]['RECCONT'][0].ChegadaLCB || timeTableGeral[i]['RECCONT'][0].chegada)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][0].ChegadaLCB ?
                                    (timeTableGeral[i]['RECCONT'][0].ChegadaLCB |
                                    date : 'dd/MM/yyyy HH:mm') :
                                    (timeTableGeral[i]['RECCONT'][0]?.chegada | date : 'dd/MM/yyyy HH:mm' : '+00:00') }}
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['RECCONT'][0] && (timeTableGeral[i]['RECCONT'][0].entrada || timeTableGeral[i]['RECCONT'][0].EntradaLCB)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][0].EntradaLCB ?
                                    (timeTableGeral[i]['RECCONT'][0].EntradaLCB | date
                                    : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['RECCONT'][0]?.entrada | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['RECCONT'][0] && (timeTableGeral[i]['RECCONT'][0].saida || timeTableGeral[i]['RECCONT'][0].SaidaLCB)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][0].SaidaLCB ?
                                    (timeTableGeral[i]['RECCONT'][0].SaidaLCB | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['RECCONT'][0]?.saida | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                        </td>
                        <td [ngClass]="timeTableGeral[i]['RECCONT'][1]?.statusEntrega"
                            (click)="timeTableGeral[i]['RECCONT'][1] ? editDialog(timeTableGeral[i]['RECCONT'][1]) : editDialog2('RECCONT')"
                            *ngIf="RECCONT">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][1]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][1]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][1]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][1]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][1]?.lastUpdate"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][1]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['RECCONT'][1]?.UpdateByUser }}</span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['RECCONT'][1]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][1]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][1]?.ID }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['RECCONT'][1]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][1]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][1]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][1]?.Transportadora"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][1]?.Transportadora }}</span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][1]?.Plate "><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][1]?.Plate }} </span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['RECCONT'][1]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][1]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][1]?.Volumes"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][1]?.Volumes }}</span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][1]?.SequenciaLCB"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Registro: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][1]?.SequenciaLCB }}</span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['RECCONT'][1] && (timeTableGeral[i]['RECCONT'][1].ChegadaLCB|| timeTableGeral[i]['RECCONT'][1].chegada)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][1]?.ChegadaLCB ?
                                    (timeTableGeral[i]['RECCONT'][1]?.ChegadaLCB |
                                    date : 'dd/MM/yyyy HH:mm' ) :
                                    (timeTableGeral[i]['RECCONT'][1]?.chegada | date :
                                    'dd/MM/yyyy HH:mm' : '+00:00') }}
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['RECCONT'][1] && (timeTableGeral[i]['RECCONT'][1].entrada || timeTableGeral[i]['RECCONT'][1].EntradaLCB)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][1]?.EntradaLCB ?
                                    (timeTableGeral[i]['RECCONT'][1]?.EntradaLCB |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['RECCONT'][1]?.entrada | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['RECCONT'][1] && (timeTableGeral[i]['RECCONT'][1].saida || timeTableGeral[i]['RECCONT'][1].SaidaLCB)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][1]?.SaidaLCB ?
                                    (timeTableGeral[i]['RECCONT'][1]?.SaidaLCB | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['RECCONT'][1]?.saida | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                        </td>
                        <td [ngClass]="timeTableGeral[i]['RECCONT'][2]?.statusEntrega"
                            (click)="timeTableGeral[i]['RECCONT'][2] ? editDialog(timeTableGeral[i]['RECCONT'][2]) : editDialog2('RECCONT')"
                            *ngIf="RECCONT">
                            <div class="infos">
                                <div class="infos">
                                    <span *ngIf="timeTableGeral[i]['RECCONT'][2]?.ID"><abbr
                                            style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                        </abbr>
                                        {{ timeTableGeral[i]['RECCONT'][2]?.ID }} </span>
                                </div>
                                <span *ngIf="timeTableGeral[i]['RECCONT'][2]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][2]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][2]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][2]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['RECCONT'][2]?.UpdateByUser }}
                                </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['RECCONT'][2]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][2]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][2]?.ID }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['RECCONT'][2]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][2]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][2]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][2]?.Transportadora"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][2]?.Transportadora }}</span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][2]?.Plate "> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][2]?.Plate }}<br> </span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['RECCONT'][2]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][2]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][2]?.Volumes"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes:</abbr>
                                    {{ timeTableGeral[i]['RECCONT'][2]?.Volumes }}</span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][2]?.SequenciaLCB"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Registro: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][2]?.SequenciaLCB }}</span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['RECCONT'][2] && (timeTableGeral[i]['RECCONT'][2].ChegadaLCB|| timeTableGeral[i]['RECCONT'][2].chegada)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][2]?.ChegadaLCB ?
                                    (timeTableGeral[i]['RECCONT'][2]?.ChegadaLCB |
                                    date : 'dd/MM/yyyy HH:mm') :
                                    (timeTableGeral[i]['RECCONT'][2]?.chegada | date :
                                    'dd/MM/yyyy HH:mm' : '+00:00') }}
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['RECCONT'][2] && (timeTableGeral[i]['RECCONT'][2].entrada || timeTableGeral[i]['RECCONT'][2].EntradaLCB)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][2]?.EntradaLCB ?
                                    (timeTableGeral[i]['RECCONT'][2]?.EntradaLCB |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['RECCONT'][2]?.entrada | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['RECCONT'][2] && (timeTableGeral[i]['RECCONT'][2].saida || timeTableGeral[i]['RECCONT'][2].SaidaLCB)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida:</abbr>
                                    {{ timeTableGeral[i]['RECCONT'][2]?.SaidaLCB ?
                                    (timeTableGeral[i]['RECCONT'][2]?.SaidaLCB | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['RECCONT'][2]?.saida | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                        </td>
                        <td [ngClass]="timeTableGeral[i]['RECCONT'][3]?.statusEntrega"
                            (click)="timeTableGeral[i]['RECCONT'][3] ? editDialog(timeTableGeral[i]['RECCONT'][3]) : editDialog2('RECCONT')"
                            *ngIf="RECCONT">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][3]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][3]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][3]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][3]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][3]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][3]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['RECCONT'][3]?.UpdateByUser }}
                                </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['RECCONT'][3]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][3]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][3]?.ID }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['RECCONT'][3]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][3]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][3]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][3]?.Transportadora"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][3]?.Transportadora }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][3]?.Plate "> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][3]?.Plate }} <br></span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['RECCONT'][3]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][3]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][3]?.Volumes"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][3]?.Volumes }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECCONT'][3]?.SequenciaLCB"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Registro: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][3]?.SequenciaLCB }}</span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['RECCONT'][3] && (timeTableGeral[i]['RECCONT'][3].ChegadaLCB || timeTableGeral[i]['RECCONT'][3].chegada)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][3]?.ChegadaLCB ?
                                    (timeTableGeral[i]['RECCONT'][3]?.ChegadaLCB|
                                    date : 'dd/MM/yyyy HH:mm') :
                                    (timeTableGeral[i]['RECCONT'][3]?.chegada | date :
                                    'dd/MM/yyyy HH:mm' : '+00:00')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['RECCONT'][3] && (timeTableGeral[i]['RECCONT'][3].entrada || timeTableGeral[i]['RECCONT'][3].EntradaLCB)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][3]?.EntradaLCB ?
                                    (timeTableGeral[i]['RECCONT'][3]?.EntradaLCB |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['RECCONT'][3]?.entrada | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['RECCONT'][3] && (timeTableGeral[i]['RECCONT'][3].saida || timeTableGeral[i]['RECCONT'][3].SaidaLCB)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['RECCONT'][3]?.SaidaLCB ?
                                    (timeTableGeral[i]['RECCONT'][3]?.SaidaLCB | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['RECCONT'][3]?.saida | date :
                                    'dd/MM/yyyy HH:mm')}}
                                </span>
                            </div>
                        </td>


<!-- /****************************************************************************************************************************************************/ -->


                        <td [ngClass]="timeTableGeral[i]['RECSIDER'][0]?.statusEntrega"
                            (click)="timeTableGeral[i]['RECSIDER'][0] ? editDialog(timeTableGeral[i]['RECSIDER'][0]) : editDialog2('RECSIDER')"
                            *ngIf="RECSIDER">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECSIDER'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][0]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECSIDER'][0]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][0]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECSIDER'][0]?.lastUpdate"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last
                                        Update.:</abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][0]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['RECSIDER'][0]?.UpdateByUser }}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECSIDER'][0]?.Transportadora"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][0]?.Transportadora }}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECSIDER'][0]?.Plate "> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][0]?.Plate }}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECSIDER'][0]?.Volumes"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][0]?.Volumes }}
                                </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECSIDER'][0]?.SequenciaLCB"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Registro: </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][0]?.SequenciaLCB }}</span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['RECSIDER'][0]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][0]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['RECSIDER'][0] && (timeTableGeral[i]['RECSIDER'][0].ChegadaLCB|| timeTableGeral[i]['RECSIDER'][0].chegada)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][0]?.ChegadaLCB?
                                    (timeTableGeral[i]['RECSIDER'][0]?.ChegadaLCB |
                                    date : 'dd/MM/yyyy HH:mm') :
                                    (timeTableGeral[i]['RECSIDER'][0]?.chegada | date :
                                    'dd/MM/yyyy HH:mm' : '+00:00')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['RECSIDER'][0] && (timeTableGeral[i]['RECSIDER'][0].entrada || timeTableGeral[i]['RECSIDER'][0].EntradaLCB)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][0]?.EntradaLCB ?
                                    (timeTableGeral[i]['RECSIDER'][0]?.EntradaLCB
                                    |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['RECSIDER'][0]?.entrada | date
                                    :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['RECSIDER'][0] && (timeTableGeral[i]['RECSIDER'][0].AtendRecebLCB)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Atend. Receb LCB: </abbr>
                                    {{ (timeTableGeral[i]['RECSIDER'][0]?.AtendRecebLCB | date : 'dd/MM/yyyy HH:mm') }}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['RECSIDER'][0] && (timeTableGeral[i]['RECSIDER'][0].FinalRecebLCB)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Final Receb LCB: </abbr>
                                    {{ (timeTableGeral[i]['RECSIDER'][0]?.FinalRecebLCB | date : 'dd/MM/yyyy HH:mm') }}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['RECSIDER'][0] && (timeTableGeral[i]['RECSIDER'][0].saida || timeTableGeral[i]['RECSIDER'][0].SaidaLCB)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][0]?.SaidaLCB ?
                                    (timeTableGeral[i]['RECSIDER'][0]?.SaidaLCB |
                                    date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['RECSIDER'][0]?.saida | date :
                                    'dd/MM/yyyy HH:mm')}}
                                </span>
                            </div>
                            <!-- {{ timeTableGeral[i]['RECSIDER'][0]?.Plate }} -->
                        </td>
                        <td [ngClass]="timeTableGeral[i]['RECSIDER'][1]?.statusEntrega"
                            (click)="timeTableGeral[i]['RECSIDER'][1] ? editDialog(timeTableGeral[i]['RECSIDER'][1]) : editDialog2('RECSIDER')"
                            *ngIf="RECSIDER">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECSIDER'][1]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][1]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECSIDER'][1]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][1]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECSIDER'][1]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][1]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['RECSIDER'][1]?.UpdateByUser }}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECSIDER'][1]?.Transportadora"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][1]?.Transportadora }}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECSIDER'][1]?.Plate "> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][1]?.Plate }}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECSIDER'][1]?.Volumes"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][1]?.Volumes }}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECSIDER'][1]?.SequenciaLCB"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Registro: </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][1]?.SequenciaLCB }}</span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['RECSIDER'][1]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][1]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['RECSIDER'][1] && (timeTableGeral[i]['RECSIDER'][1].ChegadaLCB|| timeTableGeral[i]['RECSIDER'][1].chegada)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][1]?.ChegadaLCB?
                                    (timeTableGeral[i]['RECSIDER'][1]?.ChegadaLCB
                                    |
                                    date : 'dd/MM/yyyy HH:mm') :
                                    (timeTableGeral[i]['RECSIDER'][1]?.chegada | date :
                                    'dd/MM/yyyy HH:mm' : '+00:00')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['RECSIDER'][1] && (timeTableGeral[i]['RECSIDER'][1].entrada || timeTableGeral[i]['RECSIDER'][1].EntradaLCB)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][1]?.EntradaLCB ?
                                    (timeTableGeral[i]['RECSIDER'][1]?.EntradaLCB
                                    |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['RECSIDER'][1]?.entrada | date
                                    :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['RECSIDER'][1] && (timeTableGeral[i]['RECSIDER'][1].AtendRecebLCB)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Atend. Receb LCB: </abbr>
                                    {{ (timeTableGeral[i]['RECSIDER'][1]?.AtendRecebLCB | date : 'dd/MM/yyyy HH:mm') }}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['RECSIDER'][1] && (timeTableGeral[i]['RECSIDER'][1].FinalRecebLCB)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Final Receb LCB: </abbr>
                                    {{ (timeTableGeral[i]['RECSIDER'][1]?.FinalRecebLCB | date : 'dd/MM/yyyy HH:mm') }}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['RECSIDER'][1] && (timeTableGeral[i]['RECSIDER'][1].saida || timeTableGeral[i]['RECSIDER'][1].SaidaLCB)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][1]?.SaidaLCB ?
                                    (timeTableGeral[i]['RECSIDER'][1]?.SaidaLCB |
                                    date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['RECSIDER'][1]?.saida | date :
                                    'dd/MM/yyyy HH:mm')}}
                                </span>
                            </div>
                            <!-- {{ timeTableGeral[i]['RECSIDER'][1]?.Plate }} -->
                        </td>
                        <td [ngClass]="timeTableGeral[i]['RECSIDER'][2]?.statusEntrega"
                            (click)="timeTableGeral[i]['RECSIDER'][2] ? editDialog(timeTableGeral[i]['RECSIDER'][2]) : editDialog2('RECSIDER')"
                            *ngIf="RECSIDER">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECSIDER'][2]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][2]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECSIDER'][2]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][2]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECSIDER'][2]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][2]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['RECSIDER'][2]?.UpdateByUser }}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECSIDER'][2]?.Transportadora"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][2]?.Transportadora }}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECSIDER'][2]?.Plate "> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][2]?.Plate }}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECSIDER'][2]?.Volumes"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][2]?.Volumes }}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['RECSIDER'][2]?.SequenciaLCB"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Registro: </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][2]?.SequenciaLCB }}</span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['RECSIDER'][2]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][2]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['RECSIDER'][2] && (timeTableGeral[i]['RECSIDER'][2].ChegadaLCB|| timeTableGeral[i]['RECSIDER'][2].chegada)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][2]?.ChegadaLCB?
                                    (timeTableGeral[i]['RECSIDER'][2]?.ChegadaLCB
                                    |
                                    date : 'dd/MM/yyyy HH:mm') :
                                    (timeTableGeral[i]['RECSIDER'][2]?.chegada | date :
                                    'dd/MM/yyyy HH:mm' : '+00:00')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['RECSIDER'][2] && (timeTableGeral[i]['RECSIDER'][2].entrada || timeTableGeral[i]['RECSIDER'][2].EntradaLCB)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][2]?.EntradaLCB ?
                                    (timeTableGeral[i]['RECSIDER'][2]?.EntradaLCB
                                    |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['RECSIDER'][2]?.entrada | date
                                    :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['RECSIDER'][2] && (timeTableGeral[i]['RECSIDER'][2].AtendRecebLCB)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Atend. Receb LCB: </abbr>
                                    {{ (timeTableGeral[i]['RECSIDER'][2]?.AtendRecebLCB | date : 'dd/MM/yyyy HH:mm') }}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['RECSIDER'][2] && (timeTableGeral[i]['RECSIDER'][2].FinalRecebLCB)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Final Receb LCB: </abbr>
                                    {{ (timeTableGeral[i]['RECSIDER'][2]?.FinalRecebLCB | date : 'dd/MM/yyyy HH:mm') }}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['RECSIDER'][2] && (timeTableGeral[i]['RECSIDER'][2].saida || timeTableGeral[i]['RECSIDER'][2].SaidaLCB)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['RECSIDER'][2]?.SaidaLCB ?
                                    (timeTableGeral[i]['RECSIDER'][2]?.SaidaLCB |
                                    date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['RECSIDER'][2]?.saida | date :
                                    'dd/MM/yyyy HH:mm')}}
                                </span>
                            </div>
                            <!-- {{ timeTableGeral[i]['RECSIDER'][2]?.Plate }} -->
                        </td>

                        <!-- /****************************************************************************************************************************************************/ -->

                        <td [ngClass]="timeTableGeral[i]['EXP'][0]?.statusEntrega"
                            (click)="timeTableGeral[i]['EXP'][0] ? editDialog(timeTableGeral[i]['EXP'][0]) : editDialog2('EXP')"
                            *ngIf="EXP">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EXP'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['EXP'][0]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EXP'][0]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['EXP'][0]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EXP'][0]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['EXP'][0]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['EXP'][0]?.UpdateByUser }}
                                </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['EXP'][0]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['EXP'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['EXP'][0]?.ID }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EXP'][0]?.Transportadora"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['EXP'][0]?.Transportadora }}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EXP'][0]?.Plate "><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['EXP'][0]?.Plate }}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['EXP'][0]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['EXP'][0]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EXP'][0]?.Volumes"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['EXP'][0]?.Volumes }}
                                    <br></span>
                            </div>
                            <!-- {{ timeTableGeral[i]['EXP'][0]?.Plate }} -->


                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['EXP'][0] && (timeTableGeral[i]['EXP'][0].ChegadaLCB|| timeTableGeral[i]['EXP'][0].chegada)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['EXP'][0]?.ChegadaLCB? (timeTableGeral[i]['EXP'][0]?.ChegadaLCB
                                    |
                                    date : 'dd/MM/yyyy HH:mm') :
                                    (timeTableGeral[i]['EXP'][0]?.chegada | date :
                                    'dd/MM/yyyy HH:mm' : '+00:00')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['EXP'][0] && (timeTableGeral[i]['EXP'][0].entrada || timeTableGeral[i]['EXP'][0].EntradaLCB)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['EXP'][0]?.EntradaLCB ?
                                    (timeTableGeral[i]['EXP'][0]?.EntradaLCB |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['EXP'][0]?.entrada | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['EXP'][0] && (timeTableGeral[i]['EXP'][0].saida || timeTableGeral[i]['EXP'][0].SaidaLCB)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['EXP'][0]?.SaidaLCB ? (timeTableGeral[i]['EXP'][0]?.SaidaLCB |
                                    date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['EXP'][0]?.saida | date :
                                    'dd/MM/yyyy HH:mm')}}
                                </span>
                            </div>
                        </td>
                        <td [ngClass]="timeTableGeral[i]['EXP'][1]?.statusEntrega"
                            (click)="timeTableGeral[i]['EXP'][1] ? editDialog(timeTableGeral[i]['EXP'][1]) : editDialog2('EXP')"
                            *ngIf="EXP">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EXP'][1]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['EXP'][1]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EXP'][1]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['EXP'][1]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EXP'][1]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['EXP'][1]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['EXP'][1]?.UpdateByUser }}
                                </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['EXP'][1]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['EXP'][1]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['EXP'][1]?.ID }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EXP'][1]?.Transportadora"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['EXP'][1]?.Transportadora }}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EXP'][1]?.Plate "><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['EXP'][1]?.Plate }}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['EXP'][1]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['EXP'][1]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EXP'][1]?.Volumes"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['EXP'][1]?.Volumes }}
                                    <br></span>
                            </div>
                            <!-- {{ timeTableGeral[i]['EXP'][1]?.Plate }} -->


                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['EXP'][1] && (timeTableGeral[i]['EXP'][1].ChegadaLCB|| timeTableGeral[i]['EXP'][1].chegada)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['EXP'][1]?.ChegadaLCB? (timeTableGeral[i]['EXP'][1]?.ChegadaLCB
                                    |
                                    date : 'dd/MM/yyyy HH:mm') :
                                    (timeTableGeral[i]['EXP'][1]?.chegada | date :
                                    'dd/MM/yyyy HH:mm' : '+00:00')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['EXP'][1] && (timeTableGeral[i]['EXP'][1].entrada || timeTableGeral[i]['EXP'][1].EntradaLCB)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['EXP'][1]?.EntradaLCB ?
                                    (timeTableGeral[i]['EXP'][1]?.EntradaLCB |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['EXP'][1]?.entrada | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['EXP'][1] && (timeTableGeral[i]['EXP'][1].saida || timeTableGeral[i]['EXP'][1].SaidaLCB)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['EXP'][1]?.SaidaLCB ? (timeTableGeral[i]['EXP'][1]?.SaidaLCB |
                                    date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['EXP'][1]?.saida | date :
                                    'dd/MM/yyyy HH:mm')}}
                                </span>
                            </div>
                        </td>
                        <td [ngClass]="timeTableGeral[i]['EXP'][2]?.statusEntrega"
                            (click)="timeTableGeral[i]['EXP'][2] ? editDialog(timeTableGeral[i]['EXP'][2]) : editDialog2('EXP')"
                            *ngIf="EXP">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EXP'][2]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['EXP'][2]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EXP'][2]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['EXP'][2]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EXP'][2]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['EXP'][2]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['EXP'][2]?.UpdateByUser }}
                                </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['EXP'][2]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['EXP'][2]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['EXP'][2]?.ID }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EXP'][2]?.Transportadora"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['EXP'][2]?.Transportadora }}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EXP'][2]?.Plate "><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['EXP'][2]?.Plate }}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['EXP'][2]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['EXP'][2]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EXP'][2]?.Volumes"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['EXP'][2]?.Volumes }}
                                    <br></span>
                            </div>
                            <!-- {{ timeTableGeral[i]['EXP'][2]?.Plate }} -->


                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['EXP'][2] && (timeTableGeral[i]['EXP'][2].ChegadaLCB|| timeTableGeral[i]['EXP'][2].chegada)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['EXP'][2]?.ChegadaLCB ?
                                    (timeTableGeral[i]['EXP'][2]?.ChegadaLCB |
                                    date : 'dd/MM/yyyy HH:mm') :
                                    (timeTableGeral[i]['EXP'][2]?.chegada | date :
                                    'dd/MM/yyyy HH:mm' : '+00:00')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['EXP'][2] && (timeTableGeral[i]['EXP'][2].entrada || timeTableGeral[i]['EXP'][2].EntradaLCB)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['EXP'][2]?.EntradaLCB ?
                                    (timeTableGeral[i]['EXP'][2]?.EntradaLCB |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['EXP'][2]?.entrada | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['EXP'][2] && (timeTableGeral[i]['EXP'][2].saida || timeTableGeral[i]['EXP'][2].SaidaLCB)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['EXP'][2]?.SaidaLCB ? (timeTableGeral[i]['EXP'][2]?.SaidaLCB |
                                    date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['EXP'][2]?.saida | date :
                                    'dd/MM/yyyy HH:mm')}}
                                </span>
                            </div>
                        </td>

                        <!-- /*****************************************************************************************************/// -->

                        <td [ngClass]="timeTableGeral[i]['INT'][0]?.statusEntrega"
                            (click)="timeTableGeral[i]['INT'][0] ? editDialog(timeTableGeral[i]['INT'][0]) : editDialog2('INT')"
                            *ngIf="INT">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['INT'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['INT'][0]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['INT'][0]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['INT'][0]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['INT'][0]?.Transportadora"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['INT'][0]?.Transportadora }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['INT'][0]?.Plate "><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['INT'][0]?.Plate }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['INT'][0]?.Volumes"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['INT'][0]?.Volumes }} <br></span>
                            </div>
                            <!-- {{ timeTableGeral[i]['INT'][0]?.Plate }} -->
                        </td>
                        <td [ngClass]="timeTableGeral[i]['INT'][1]?.statusEntrega"
                            (click)="timeTableGeral[i]['INT'][1] ? editDialog(timeTableGeral[i]['INT'][1]) : editDialog2('INT')"
                            *ngIf="INT">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['INT'][1]?.Transportadora"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['INT'][1]?.Transportadora }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['INT'][1]?.Plate "> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['INT'][1]?.Plate }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['INT'][1]?.Volumes"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['INT'][1]?.Volumes }} <br></span>
                            </div>
                            <!-- {{ timeTableGeral[i]['INT'][1]?.Plate }} -->
                        </td>
                        <td [ngClass]="timeTableGeral[i]['INT'][2]?.statusEntrega"
                            (click)="timeTableGeral[i]['INT'][2] ? editDialog(timeTableGeral[i]['INT'][2]) : editDialog2('INT')"
                            *ngIf="INT">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['INT'][2]?.Transportadora"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['INT'][2]?.Transportadora }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['INT'][2]?.Plate "><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['INT'][2]?.Plate }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['INT'][2]?.Volumes"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['INT'][2]?.Volumes }} <br></span>
                            </div>
                            <!-- {{ timeTableGeral[i]['INT'][2]?.Plate }} -->
                        </td>
                        <td [ngClass]="timeTableGeral[i]['INT'][3]?.statusEntrega"
                            (click)="timeTableGeral[i]['INT'][3] ? editDialog(timeTableGeral[i]['INT'][3]) : editDialog2('INT')"
                            *ngIf="INT">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['INT'][3]?.Transportadora"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['INT'][3]?.Transportadora }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['INT'][3]?.Plate "><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['INT'][3]?.Plate }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['INT'][3]?.Volumes"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['INT'][3]?.Volumes }} <br></span>
                            </div>
                            <!-- {{ timeTableGeral[i]['INT'][3]?.Plate }} -->
                        </td>

                        <!-- /********************************************************************************************************************************/ -->

                        <td [ngClass]="timeTableGeral[i]['EMB'][0]?.statusEntrega"
                            (click)="timeTableGeral[i]['EMB'][0] ? editDialog(timeTableGeral[i]['EMB'][0]) : editDialog2('EMB')"
                            *ngIf="EMB">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EMB'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['EMB'][0]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EMB'][0]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['EMB'][0]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EMB'][0]?.lastUpdate"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['EMB'][0]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['EMB'][0]?.UpdateByUser }} </span>
                            </div>
                            <!-- (click)=" editDialog(timeTableGeral[i]['EMB'][0])"  -->
                            <div *ngIf="timeTableGeral[i]['EMB'][0]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['EMB'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['EMB'][0]?.ID }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EMB'][0]?.Transportadora"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['EMB'][0]?.Transportadora }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EMB'][0]?.Plate "><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['EMB'][0]?.Plate }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EMB'][0]?.Volumes"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['EMB'][0]?.Volumes }} <br></span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['EMB'][0]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['EMB'][0]?.Fornecedores }}<br> </span>
                            </div>
                            <!-- {{ timeTableGeral[i]['EMB'][0]?.Plate }} -->
                        </td>
               
                        <!-- /********************************************************************************************************************************/ -->

               
                        <td [ngClass]="timeTableGeral[i]['EMBMR'][0]?.statusEntrega"
                            (click)="timeTableGeral[i]['EMBMR'][0] ? editDialog(timeTableGeral[i]['EMBMR'][0]) : editDialog2('EMBMR')"
                            *ngIf="EMB">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EMBMR'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['EMBMR'][0]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EMBMR'][0]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['EMBMR'][0]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EMBMR'][0]?.lastUpdate"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['EMBMR'][0]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['EMBMR'][0]?.UpdateByUser }} </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['EMBMR'][0]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['EMBMR'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['EMBMR'][0]?.ID }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EMBMR'][0]?.Transportadora"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['EMBMR'][0]?.Transportadora }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EMBMR'][0]?.Plate "><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['EMBMR'][0]?.Plate }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['EMBMR'][0]?.Volumes"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['EMBMR'][0]?.Volumes }} <br></span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['EMBMR'][0]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['EMBMR'][0]?.Fornecedores }}<br> </span>
                            </div>
                            <!-- {{ timeTableGeral[i]['EMBMR'][0]?.Plate }} -->
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</body>

<body>
    <div class="container">
        <table class="table-selects">
            <thead>
                <tr>
                    <th class="flex">
                        <h1>VEICULOS EXCEDENTES</h1>
                    </th>
                </tr>
            </thead>
        </table>
    </div>
    <div class="table-container scrollable-container">
        <table>
            <thead class="sticky-header">
                <tr>
                    <th class="titulo-coluna" colspan="2">
                        <span class="semFundo">Veículo</span>
                    </th>
                    <th class="titulo-coluna" colspan="2">
                        <span class="semFundo">Volumes</span>
                    </th>
                    <th class="titulo-coluna" colspan="2">
                        <span class="semFundo">Area</span>
                    </th>
                    <th class="titulo-coluna" colspan="2">
                        <span class="semFundo">Janelas</span>
                    </th>
                    <th class="titulo-coluna" colspan="2">
                        <span class="semFundo">Transportadora</span>
                    </th>
                    <th class="titulo-coluna" colspan="2">
                        <span class="semFundo">Fornecedor</span>
                    </th>
                    <th class="titulo-coluna" colspan="2">
                        <span class="semFundo">Chegada</span>
                    </th>
                    <th class="titulo-coluna" colspan="2">
                        <span class="semFundo">Entrada</span>
                    </th>
                    <th class="titulo-coluna" colspan="2">
                        <span class="semFundo">Saida</span>
                    </th>
                    <th class="titulo-coluna" colspan="1">
                        <span class="semFundo">Editar</span>
                    </th>
                </tr>
            </thead>
            <tbody *ngFor="let item of timeTableExcessoFiltrados">
                <tr>
                    <td [ngClass]="item?.statusEntrega" colspan="2">
                        <label class="labelExcesso">{{ item.Plate }}
                            <span *ngIf="item.idContainer"><abbr
                                    style="color: #000000; font-size: 1.8vh; font-weight: bold;">/ Container: </abbr>
                                {{ item.ID }}<br> </span> </label>
                    </td>
                    <!-- <td class="align-left input-maior">
                            <input type="text" name="Plate" [(ngModel)]="item.Plate" class="modal-input1">
                        </td> -->
                    <td [ngClass]="item?.statusEntrega" colspan="2">
                        <label class="labelExcesso">{{item.Volumes}}</label>
                    </td>
                    <td [ngClass]="item?.statusEntrega" colspan="2">
                        <label class="labelExcesso">{{item.Area}}</label>
                    </td>
                    <!-- <td [ngClass]="item?.statusEntrega" class="align-left input-maior">
                            <input type="text" name="Volumes" [(ngModel)]="item.Volumes" class="modal-input1">
                        </td> -->
                    <td [ngClass]="item?.statusEntrega" colspan="2">
                        <label class="labelExcesso">{{item.Janela}}</label>
                    </td>
                    <!-- <td [ngClass]="item?.statusEntrega" class="align-left input-maior">
                            <input type="text" name="janela" [(ngModel)]="item.janela" class="modal-input1">
                        </td> -->
                    <td [ngClass]="item?.statusEntrega" colspan="2">
                        <label class="labelExcesso">{{item.Transportadora}}</label>
                    </td>
                    <td [ngClass]="item?.statusEntrega" colspan="2">
                        <label class="labelExcesso">{{item.Fornecedores}}</label>
                    </td>
                    <td [ngClass]="item?.statusEntrega" colspan="2">
                        <label class="labelExcesso"> {{ item.ChegadaLCB ? (item?.ChegadaLCB |
                            date : 'dd/MM/yyyy HH:mm') : (item?.chegada | date :
                            'dd/MM/yyyy HH:mm' : '+00:00') }}</label>
                    </td>
                    <td [ngClass]="item?.statusEntrega" colspan="2">
                        <label class="labelExcesso"> {{ item.EntradaLCB ? (item.EntradaLCB | date
                            : 'dd/MM/yyyy HH:mm') : (item?.entrada | date :
                            'dd/MM/yyyy HH:mm') }}</label>
                    </td>
                    <td [ngClass]="item?.statusEntrega" colspan="2">
                        <label class="labelExcesso"> {{ item.SaidaLCB ? (item.SaidaLCB | date :
                            'dd/MM/yyyy HH:mm') : (item?.saida | date :
                            'dd/MM/yyyy HH:mm') }}</label>
                    </td>
                    <td class="labelExcesso action">
                        <!-- Outros inputs para as colunas restantes -->
                        <!-- <button class="button-spacing" (click)="salvar('Placa',item); editMode[i] = false">Salvar</button> -->
                        <button (click)="editDialog(item)">Editar</button>
                      </td>
                    <!-- <td class="align-left input-maior">
                            <input type="text" name="janela" [(ngModel)]="item.janela" class="modal-input1">
                        </td> -->
                    <!-- <td colspan="2">
                        <label class="labelExcesso">{{item.local}}</label>
                    </td> -->
                    <!-- <td class="align-left input-maior">
                            <input type="text" name="janela" [(ngModel)]="item.janela" class="modal-input1">
                        </td> -->
                </tr>
            </tbody>
        </table>
    </div>
</body>

<clr-modal [(clrModalOpen)]="dialogOpen" [clrModalSize]="'sm'" class="dialog-container">
    <h3 class="modal-title">Detalhes</h3>
    <div class="modal-body">
        <form class="inputs">
            <table class="table2000">
                <tr class="flexEdit">
                    <td>
                        <label class="modal-label">Transportadora</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="transportadora" [(ngModel)]="item.transportadora" class="modal-input1">
                        <!-- <input type="text" name="ID" [(ngModel)]="item.ID" class="modal-input1"> -->
                    </td>
                    <td>
                        <label class="modal-label">Placa</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="Plate" [(ngModel)]="item.Plate" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Volumes</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="Volumes" [(ngModel)]="item.Volumes" class="modal-input1">
                    </td>
                </tr>
                <tr class="flexEdit">
                    <td *ngIf="edit2">
                        <label class="modal-label">Destino 1</label>
                    </td>
                    <td class="align-left input-maior" *ngIf="edit2">
                        <input type="text" name="forn1" [(ngModel)]="item.forn1" class="modal-input1">
                    </td>
                </tr>
                <tr class="flexEdit">
                    <td>
                        <label class="modal-label">Janela Original</label>
                    </td>
                    <td class="align-left input-maior">
                        <input [disabled]="!edit2" type="date" name="dataJanelaTimeTable" [(ngModel)]="item.dataJanelaTimeTable"
                            class="modal-input1">
                        <input [disabled]="!edit2" type="time" name="horaJanelaTimeTable" [(ngModel)]="item.horaJanelaTimeTable"
                            class="modal-input1">
                    </td>
                </tr>
                <tr *ngIf="!edit2" class="flexEdit">
                    <td>
                        <label class="modal-label">Janela</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="date" name="dataAlterada"
                            [(ngModel)]="item.dataAlterada" class="modal-input1">
                        <input type="time" name="horaAlterada"
                            [(ngModel)]="item.horaAlterada" class="modal-input1">
                    </td>
                </tr>
                <tr class="flexEdit">
                    <td class="input-maior">
                        <label class="modal-label">Motivo da alteração*</label>
                        <select id="motAlteracao" name="motAlteracao" [(ngModel)]="item.motAlteracao"
                            class="modal-select" (blur)="onFieldTouched()">
                            <option *ngFor="let opcao of opcoesMotivo" [value]="opcao.valor">
                                {{ opcao.descricao }}
                              </option>
                            <!-- <option value=0>-</option>
                            <option value=1>Atraso no transporte/Transportadora</option>
                            <option value=2>Atraso no fornecedor</option>
                            <option value=3>Atraso no recebimento/SCANIA</option>
                            <option value=4>Atraso no recebimento/LCB</option>
                            <option value=5>Excesso de veículos no mesmo horário</option>
                            <option value=6>Chegada antecipada</option>                     -->
                        </select>
                        <div
                            *ngIf="campoTocado && (item.motAlteracao == null || item.motAlteracao == undefined || item.motAlteracao == 0)">
                            <small class="text-danger">Required</small>
                        </div>
                    </td>
                </tr>
                <tr *ngIf="item.idContainer" class="flexEdit">
                    <td>
                        <label class="modal-label">Nº Container</label>
                    </td>
                    <td class="align-left input-maior">
                        <input disabled type="text" name="idContainer" [(ngModel)]="item.idContainer" class="modal-input1">
                    </td>
                </tr>
                <tr *ngIf="item.idContainer" class="flexEdit">
                    <td>
                        <label class="modal-label">Nº Container Alugado</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="CTNRAlugado" [(ngModel)]="item.CTNRAlugado" class="modal-input1">
                    </td>
                </tr>
                <tr class="flexEdit" *ngIf="item.forn2">
                    <td>
                        <label class="modal-label">Destino 2</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="forn2" [(ngModel)]="item.forn2" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Janela 2</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="jan2" [(ngModel)]="item.jan2" class="modal-input1">
                    </td>
                </tr>
                <tr class="flexEdit" *ngIf="item.forn3">
                    <td>
                        <label class="modal-label">Destino 3</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="forn3" [(ngModel)]="item.forn3" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Janela 3</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="jan3" [(ngModel)]="item.jan3" class="modal-input1">
                    </td>
                </tr>
                <tr class="flexEdit" *ngIf="item.forn4">
                    <!-- <td>
                        <label class="modal-label">Destino 4</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="forn4" [(ngModel)]="item.forn4" class="modal-input1">
                    </td> -->
                    <td>
                        <label class="modal-label">Janela 4</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="jan4" [(ngModel)]="item.jan4" class="modal-input1">
                    </td>
                </tr>
                <tr class="flexEdit">
                    <td>
                        <label class="modal-label">Fornecedores</label>
                    </td>
                    <td class="input-maior">
                        <input [disabled]="!edit2" type="text" name="Fornecedores" [(ngModel)]="item['Fornecedores']"
                            class="modal-input1 letraMenor">
                    </td>
                </tr>
            </table>
            <div class="modal-div botoes">
                <button *ngIf="!edit2" class="modal-button" type="button" (click)="reservaEmbalagem(item)">Coletar
                    Embalagem</button>
                <button *ngIf="!edit2" class="modal-button" type="button" (click)="reutilizarEXP(item)">Reutilizar
                    Container</button>
                <button *ngIf="!edit2" class="modal-button" type="button" (click)="deleteItem(item)">Cancelar
                    Reserva</button>
                <button *ngIf="!edit2" [disabled]="isCarrierEnabled" class="modal-button" type="button"
                    (click)="FinalizarViagem(item)">Finalizar Viagem</button>
                <button class="modal-button" type="button" (click)="salvar()">Save</button>
                <button class="modal-button" type="button" (click)="cancel()">Cancel</button>
                <!-- <input  type="checkbox" name="coletaEmbalagem" [(ngModel)]="item.coletaEmbalagem" class="modal-input1"><abbr  style="color: #dbdbdb; font-size: 1.8vh; font-weight: bold;">Coletar Embalagem</abbr> -->
                <button *ngIf="!edit2" [disabled]="isCarrierEnabled" class="modal-button" type="button"
                    (click)="deleteItem(item)">Delete</button>
            </div>
        </form>
    </div>
</clr-modal>


<div *ngIf="!totalMR || isLoading" class="spinner-overlay">
    <div class="spinner">
        <mat-spinner></mat-spinner>
    </div>
</div>